export var SecurityFindingSortField;
(function (SecurityFindingSortField) {
    SecurityFindingSortField["SECURITY_FINDING_SORT_FIELD_DETECTOR_TYPE"] = "DETECTOR_TYPE";
    SecurityFindingSortField["SECURITY_FINDING_SORT_FIELD_RISK_LEVEL"] = "RISK_LEVEL";
    SecurityFindingSortField["SECURITY_FINDING_SORT_FIELD_STATUS"] = "STATUS";
    SecurityFindingSortField["SECURITY_FINDING_SORT_FIELD_RESOURCE_NAME"] = "RESOURCE_NAME";
    SecurityFindingSortField["SECURITY_FINDING_SORT_FIELD_SNAPSHOTS_COUNT"] = "SNAPSHOTS_COUNT";
})(SecurityFindingSortField || (SecurityFindingSortField = {}));
